import { useApp } from '../context/AppContext'
import { showSaveError } from '../screens/settings/toast'
import { Icon } from '../ui/Icon'
import { openPortal } from './portal'
import { OVERDUE_LINE } from './rungs'
import { overdue, useBilling } from './useBilling'
import './billing.css'

// OverdueBanner is Today's line while her last payment to Harmovi has
// failed (spec 1.5). Nothing else changes for her; the banner opens Stripe's
// billing portal to update her card, and goes once a payment succeeds.
export default function OverdueBanner() {
  const { dispatch } = useApp()
  const { billing } = useBilling()
  if (!overdue(billing)) return null
  const open = () => {
    openPortal().catch((e) => showSaveError(dispatch, e))
  }
  return (
    <button type="button" className="overdue-banner" onClick={open}>
      {OVERDUE_LINE} <Icon name="chevron-right" size={14} />
    </button>
  )
}
